import { PARTNER_LEVELS } from 'cpool-constants';
import { z } from 'zod';

// NOTE: in the future, when the partner API documentation contains all the enum values, we should use the partner constants from cpool-constants in the schema.
// NOTE: the constants are defined in cpool-constants/src/partner.ts
// NOTE: the documentation is available at https://partner-info-api-791662682475.europe-west3.run.app/docs#/
export const schemaPartnerResponse = z.object({
    account_id_ehyp: z.string().nullable().optional(),
    account_id_europace_abacus: z.string().nullable().optional(),
    account_id_europace_baufinex: z.string().nullable().optional(),
    account_id_europace_forum: z.string().nullable().optional(),
    account_id_europace_kreditde: z.string().nullable().optional(),
    account_id_europace_starpool: z.string().nullable().optional(),
    account_id_procheck: z.string().nullable().optional(),
    address: z.string().nullable().optional(),
    assigned_advisor_id: z.string().nullable().optional(),
    bank_name: z.string().nullable().optional(),
    bf_commission_on_loan_amount: z.boolean().nullable().optional(),
    bf_commission_percentage: z.number().nullable().optional(),
    city: z.string().nullable().optional(),
    country: z.string().nullable().optional(),
    debtor_number: z.string().nullable().optional(),
    direct_partner_company_name: z.string().nullable().optional(),
    direct_partner_first_name: z.string().nullable().optional(),
    direct_partner_id: z.string(),
    direct_partner_last_name: z.string().nullable().optional(),
    direct_partner_name: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    financial_proxy_partner_id: z.string().nullable().optional(),
    hgb84_level: z.string().nullable().optional(),
    hgb93_level_bf: z.string().nullable().optional(),
    hgb93_level_pk: z.string().nullable().optional(),
    hierarchy_parent: z
        .union([z.record(z.unknown()), z.string()])
        .nullable()
        .optional(),
    hubspot_url: z.string().nullable().optional(),
    iban: z.string().nullable().optional(),
    ik_commission_on_loan_amount: z.boolean().nullable().optional(),
    ik_commission_percentage: z.number().nullable().optional(),
    merged_direct_partner_ids: z.array(z.string()).optional(),
    onboarding_status: z.string().nullable().optional(),
    partner_level: z.array(z.union([z.nativeEnum(PARTNER_LEVELS), z.string()])).optional(),
    phone: z.string().nullable().optional(),
    pk_commission_on_loan_amount: z.boolean().nullable().optional(),
    pk_commission_percentage: z.number().nullable().optional(),
    show_phone_in_form: z.boolean().nullable().optional(),
    zip: z.string().nullable().optional(),
});

export type Schema_PartnerResponse = z.infer<typeof schemaPartnerResponse>;

// cpool-internal partner fields - not part of the Partner API response, only ever set by our own system.
export const schemaPartnerMeta = z.object({
    locked: z.boolean().nullish(),
});

export type Schema_PartnerMeta = z.infer<typeof schemaPartnerMeta>;

export const schemaPartner = schemaPartnerResponse.merge(schemaPartnerMeta);

export type Schema_Partner = z.infer<typeof schemaPartner>;
